/**
 * Filter types that are used in the title for BRP pages.
 */
export const filterTypesInTitle = [
  'jewellerytype',
  'moreinfo',
  'breed',
]
